import React from 'react';
import { Link } from 'react-router';

function Toolbar({
  count,
  // deleteMembers,
  groupId,
}) {
  return (
    <div className="admin_list">
      <h5>Members (<span>{count}</span>)</h5>
      <Link className="button_classic" to={`/groups/${groupId}/members/add`}>Add members</Link>
      {/* <a className="button_delete" onClick={deleteMembers}>Delete</a> */}
    </div>
  );
}

export default Toolbar;



// WEBPACK FOOTER //
// ./src/components/Admin/StudyGroups/GroupMembers/Toolbar.jsx